define.alias("ember-power-select/components/power-select/label", "media/components/power-select/label");